<p-messages key="info"></p-messages>
<p-toast key="toast" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="positionDialog" [position]="diagPosition" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
      <div class="row" >
          <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
      </div>
      <div class="row">
          <div class="col-md-2 offset-5">
              <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
          </div>
      </div>
  </div>
</div>
<div *ngIf='displayState.caseDiv'>
    <div class="row" hidden>
        <div class="col-md-4 offset-1">
            <div class="card bg-light" style="margin-top: 10px;">
            <div class="card-body" style="background-color:snow">
                <table class="table table-responsive">
                    <tr>
                        <td class="prd-label"> Case #/APN </td>
                        <td> {{applicationCase.caseNum}} / {{applicationProperty.apn}} </td>
                    </tr>
                    <tr>
                        <td class="prd-label"> Days to Expiration </td>
                        <td> {{daysToExpiration}} </td>
                    </tr>
                    <tr>
                        <td class="prd-label"> Appraiser </td>
                        <td *ngIf="applicationAssessor">{{ applicationAssessor.appraiserName? applicationAssessor.appraiserName: ""}}</td>
                    </tr>
                    <tr>
                        <td class="prd-label"> Complex Case</td>
                        <td *ngIf="applicationAssessor">{{ applicationAssessor.complexCase === true?"Yes" : "No"}}</td>
                    </tr>
                </table>
            </div>
            </div>
        </div>
        <div class="col-md-6">
            <app-case-status [caseId] = 'caseId' [userRole]='userRole'></app-case-status>
        </div>
    </div>
    <br />
    <div class="row" style="margin-bottom: 5px;">
        <div class="col-md-2 offset-1">
            <button class="btn btn-sm btn-link" (click) = "openAllSections()">Open all Sections</button>
        </div>
        <div class="col-md-2">
            <button class="btn btn-sm btn-link" (click) = "closeAllSections()">Close all Sections</button>
        </div>
        <br />
        <div class="col-md-2 offset-2" style="text-align: right;">
            <button class="btn btn-success" (click)="validateCase()">Save Case</button>
        </div>
        <div class="col-md-2">
            <button class="btn btn-secondary" (click)="exitCase()">Exit without Saving</button>
        </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-10 offset-1">
      <p-accordion [multiple]="true" [activeIndex]="accordionOpenIndex">
        <p-accordionTab header="Case">
          <div class="card bg-light">
            <div class="card-body">
              <div class="form-row">
                <label for="txtDateReceived" class="col-sm-1 col-form-label prd-label">Dt Received</label>
                <p-calendar id="txtDateReceived" class="col-md-2" [(ngModel)]="applicationCase.dateReceived" showButtonBar="true"></p-calendar>
                <label for="txtDatePostmarked" class="col-sm-1 col-form-label prd-label">Dt Postmarked</label>
                <p-calendar id="txtDatePostmarked" [(ngModel)]='applicationCase.datePostmarked'  showButtonBar="true" class="col-sm-2"></p-calendar>
                <label for="txtDateConfirmationReceived" class="col-sm-2 col-form-label prd-label">Date Confirm Rcvd</label>
                <p-calendar id="txtDateConfirmationReceived" [(ngModel)]='applicationCase.dateConfirmationReceived'  showButtonBar="true" class="col-sm-2"></p-calendar>
                <span *ngIf='eFileId' class="col-sm-1 offset-1"><h6 style="color: blueviolet; font-weight: bold;">E-Filed</h6></span>
              </div>
              <br/>
              <div class="form-row">
                <label for="chkWaiverGranted" class="col-sm-1 col-form-label prd-label">Waiver Granted</label>
                <input id="chkWaiverGranted" type="checkbox" [(ngModel)]='applicationCase.waiverReceived' class="form-control col-sm-1">
                <label for="txtWaiverExpDate" class="col-sm-1 col-form-label prd-label">Waiver Exp Date</label>
                <p-calendar id="txtWaiverExpDate" [(ngModel)]='applicationCase.waiverExpDate' class="col-sm-2"></p-calendar>
                <label for="chkPaid" class="col-sm-1 col-form-label prd-label">Paid</label>
                <input id="chkPaid" [(ngModel)]='isPaid' type="checkbox" disabled class="form-control col-sm-1">
                <label for="txtReceipt" class="col-sm-1 col-form-label prd-label">Receipt #</label>
                <input id="txtReceipt" [(ngModel)]='applicationCase.receiptNum' class="form-control col-sm-2" (change)='receiptChange()'>
              </div>
              <br />
              <div class="form-row" [hidden]="true">
                <label for="txtComment" class="col-sm-1 col-form-label prd-label">Comment</label>
                <textarea id="txtComment" [(ngModel)]='applicationCase.comment' class="form-control col-sm-8" > </textarea>
              </div>
            </div>
          </div>

        </p-accordionTab>
        <p-accordionTab header="Applicant">
          <app-case-applicant [caseId]='caseId' [applicantType]='applicantType' (changeEvent)='updateApplicant($event)'> </app-case-applicant>
        </p-accordionTab>
        <p-accordionTab header="Agent">
          <app-case-agent [caseId]='caseId' (changeEvent)='updateAgent($event)'> </app-case-agent>
        </p-accordionTab>
        <p-accordionTab header="Property">
          <app-case-property [caseId]='caseId' [myProp]='applicationProperty' (changeEvent)='updateProperty($event)'> </app-case-property>
        </p-accordionTab>
        <p-accordionTab header="Value">
          <app-case-value [caseId]='caseId' [myProp]='applicationProperty' (changeEvent)='updateValues($event)'> </app-case-value>
        </p-accordionTab>
        <p-accordionTab header="Facts">
          <app-case-facts [caseId]="caseId" (changeEvent)='updateFacts($event)'></app-case-facts>
        </p-accordionTab>
        <p-accordionTab header="Minutes" *ngIf='!isNewCase'>
          <!-- <app-case-minutes [caseId]='caseId' (changeEvent)='updateMinutes($event)'></app-case-minutes> -->
        </p-accordionTab>
        <p-accordionTab header="Documents" *ngIf='!isNewCase'>
          <app-case-docs [caseId]='caseId' [userRole]='userRole' (changeEvent)='updateDocs($event)'></app-case-docs>
        </p-accordionTab>
        <p-accordionTab header="E-file Documents" *ngIf='!isNewCase'>
          <app-case-efile [caseId]='caseId'></app-case-efile>
        </p-accordionTab>
      </p-accordion>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-2 offset-2" style="text-align: right;">
        <button class="btn btn-success" (click)="validateCase()">Save Case</button>
      </div>
      <div class="col-md-2">
        <button class="btn btn-secondary" (click)="exitCase()">Exit without Saving</button>
      </div>
    </div>
</div>
